import React from 'react';
import Input from '../Common/InputField';
import DateInput from '../Common/DateInput';
import Select from '../Common/Select';
import {
    asset_status_options,
    yes_no_options
} from './utils';
import PropTypes from 'prop-types';
import { TranslateW } from '../../Utils/Languages/Translate';
import Enums from '../../enums';
import FormFieldItem, { CreateInventoryFormPanel } from "./FormLayout";

const Subsystem = ({
    aquireLocation,
    aquireLocationsOptions,
    setAquireLocation,
    newPurchaseAquisition,
    setNewPurchaseAquisition,
    locations,
    location,
    setLocation,
    name,
    setName,
    assetStatus,
    setAssetStatus,
    tagNumber,
    setTagNumber,
    serialNumber,
    setSerialNumber,
    acquisitionDate,
    setAquisitionDate,
    disbursementDate,
    setDisbursementDate,
    installDate,
    setInstallDate,
    locationOnSite,
    setLocationOnsite,
    manufacturer,
    setManufacturer,
    manufacturers,
    manufactureDate,
    setManufactureDate,
    modelNumber,
    setModelNumber,
    modelYear,
    setModelYear,
    years,
    brand,
    setBrand,
    poNumber,
    setPONumber,
    lifeTime,
    setLifeTime,
    lifeTimeOptions,
    id,
    ErrorObject,
    subLocationOptions,
    subLocation,
    setSubLocation,
}) => {
    return (
        <CreateInventoryFormPanel enabled={false}>
            {
                id === 0 && (
                    <FormFieldItem>
                        <Select
                            required
                            value={newPurchaseAquisition}
                            label={TranslateW("createAsset.assetAcquisitionQuestionRevealer.purchase-or-acquisition")}
                            options={yes_no_options}
                            onChange={e => setNewPurchaseAquisition(e.target.value)}
                            error={ErrorObject.NewPurchaseAquisition}
                        />
                    </FormFieldItem>
                )
            }
            {
                newPurchaseAquisition === 1 && (
                    <FormFieldItem>
                        <Select
                            required
                            value={aquireLocation}
                            label={TranslateW("createAsset.acquisitionFormRevealer.acquired-from-location")}
                            options={aquireLocationsOptions}
                            onChange={e => setAquireLocation(e.target.value)}
                            error={ErrorObject.AquireLocation}
                        />
                    </FormFieldItem>
                )
            }
            <FormFieldItem>
                <Select
                    required
                    value={location}
                    label={TranslateW("assetDetailsDashboardTab.location")}
                    options={locations}
                    onChange={e => setLocation(e.target.value)}
                    error={ErrorObject.Location}
                    disabled
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={subLocation}
                    label={TranslateW("assetDetailsMainTab.subLocation")}
                    options={subLocationOptions}
                    onChange={e => setSubLocation(e.target.value)}
                    disabled
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    label={TranslateW("assetDetailsDashboardTab.name")}
                    value={name}
                    onChange={e => setName(e.target.value)}
                    error={ErrorObject.Name}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required
                    value={assetStatus}
                    label={TranslateW("assetEditView.assetStatus-field")}
                    options={asset_status_options}
                    onChange={e => setAssetStatus(e.target.value)}
                    error={ErrorObject.AssetStatus}
                />
            </FormFieldItem>

            <FormFieldItem>
                <Input
                    fullWidth
                    label={TranslateW("assetDetailsDashboardTab.tag-number")}
                    value={tagNumber}
                    onChange={e => setTagNumber(e.target.value)}
                    required={!serialNumber}
                    error={ErrorObject.TagNumber}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label={TranslateW("assetDetailsDashboardTab.serial-number")}
                    value={serialNumber}
                    onChange={e => setSerialNumber(e.target.value)}
                    required={!tagNumber}
                    error={ErrorObject.SerialNumber}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    {...(!id ? { isRequired: true } : {})}
                    allowPast={true}
                    date={acquisitionDate}
                    onChange={date => setAquisitionDate(date)}
                    label={TranslateW("assetDetailsMainTab.acquisition-date")}
                    error={ErrorObject.AcquisitionDate}
                    customHelperText={ErrorObject.AcquisitionDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowFuture={false}
                    allowPast={true}
                    date={disbursementDate}
                    onChange={date => setDisbursementDate(date)}
                    label={TranslateW("assetDetailsMainTab.disbursement-date")}
                    disabled={assetStatus === Enums.SE.AssetStatus.Active}
                    error={ErrorObject.DisbursementDate}
                    customHelperText={ErrorObject.DisbursementDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    {...(!id ? { isRequired: true } : {})}
                    allowPast={true}
                    allowFuture={false}
                    date={installDate}
                    onChange={date => setInstallDate(date)}
                    label={TranslateW("assetDetailsMainTab.install-date")}
                    error={ErrorObject.InstallDate}
                    customHelperText={ErrorObject.InstallDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    multiLine
                    label={TranslateW("assetDetailsMainTab.location-onsite")}
                    value={locationOnSite}
                    onChange={e => setLocationOnsite(e.target.value)}
                    error={ErrorObject.LocationOnSite}
                    customHelperText={ErrorObject.LocationOnSite}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={manufacturer}
                    label={TranslateW("assetEditView.manufacturer")}
                    options={manufacturers}
                    onChange={e => setManufacturer(e.target.value)}
                    error={ErrorObject.Manufacturer}
                    customHelperText={ErrorObject.Manufacturer}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowPast={true}
                    allowFuture={false}
                    date={manufactureDate}
                    onChange={date => setManufactureDate(date)}
                    label={TranslateW("assetEditView.manufacturer-date")}
                    error={ErrorObject.ManufactureDate}
                    customHelperText={ErrorObject.ManufactureDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label={TranslateW("assetEditView.manufacturer-model-number")}
                    value={modelNumber}
                    onChange={e => setModelNumber(e.target.value)}
                    error={ErrorObject.ModelNumber}
                    customHelperText={ErrorObject.ModelNumber}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={modelYear}
                    label={TranslateW("assetEditView.modelYear")}
                    options={years}
                    onChange={e => setModelYear(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label={TranslateW("assetEditView.po-number")}
                    value={poNumber}
                    onChange={e => setPONumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label={TranslateW("assetEditView.brand")}
                    value={brand}
                    onChange={e => setBrand(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={lifeTime}
                    label={TranslateW("assetEditView.expected-lifetime-years")}
                    options={lifeTimeOptions}
                    onChange={e => setLifeTime(e.target.value)}
                />
            </FormFieldItem>
        </CreateInventoryFormPanel>
    )
};

Subsystem.propTypes = {
    newPurchaseAquisition: PropTypes.array.isRequired,
    setNewPurchaseAquisition: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    setLocation: PropTypes.func.isRequired,
    subLocationOptions: PropTypes.array.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    tagNumber: PropTypes.string.isRequired,
    setTagNumber: PropTypes.func.isRequired,
    serialNumber: PropTypes.string.isRequired,
    setSerialNumber: PropTypes.func.isRequired,
    acquisitionDate: PropTypes.string.isRequired,
    setAquisitionDate: PropTypes.func.isRequired,
    disbursementDate: PropTypes.string.isRequired,
    setDisbursementDate: PropTypes.func.isRequired,
    installDate: PropTypes.string.isRequired,
    setInstallDate: PropTypes.func.isRequired,
    locationOnSite: PropTypes.string.isRequired,
    setLocationOnsite: PropTypes.func.isRequired,
    manufacturer: PropTypes.string.isRequired,
    setManufacturer: PropTypes.func.isRequired,
    manufacturers: PropTypes.array.isRequired,
    manufactureDate: PropTypes.string.isRequired,
    setManufactureDate: PropTypes.func.isRequired,
    modelNumber: PropTypes.string.isRequired,
    setModelNumber: PropTypes.func.isRequired,
    modelYear: PropTypes.string.isRequired,
    setModelYear: PropTypes.func.isRequired,
    years: PropTypes.array.isRequired,
    brand: PropTypes.string.isRequired,
    setBrand: PropTypes.func.isRequired,
    poNumber: PropTypes.string.isRequired,
    setPONumber: PropTypes.func.isRequired,
    lifeTime: PropTypes.string.isRequired,
    setLifeTime: PropTypes.func.isRequired,
    lifeTimeOptions: PropTypes.array.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default Subsystem;
